import { GraphQLClient } from 'graphql-request';
import { gql } from 'urql';
import { CreateFileInput, Mutation, Query, QueryFileArgs } from '../generated/graphql';
import { FileFragment } from './fragments';

export const clientCreateFile = async (client: GraphQLClient, input: CreateFileInput) => {
  const res = await client.request<Pick<Mutation, 'createFile'>>(
    gql`
      ${FileFragment}
      mutation CreateFile($input: CreateFileInput!) {
        createFile(input: $input) {
          file {
            ...FileFragment
          }
        }
      }
    `,
    { input }
  );
  return res.createFile;
};

export const clientGetFile = async (client: GraphQLClient, input: QueryFileArgs): Promise<Query['file']> => {
  const res = await client.request<Pick<Query, 'file'>, QueryFileArgs>(
    gql`
      ${FileFragment}
      query File($tenantID: ID!, $id: ID!) {
        file(tenantID: $tenantID, id: $id) {
          ...FileFragment
        }
      }
    `,
    input
  );
  return res.file;
};

export const deleteFileMutation = gql`
  mutation DeleteFile($input: DeleteFileInput!) {
    deleteFile(input: $input) {
      changeToken
      __typename
    }
  }
`;
